import { Injectable } from '@angular/core';
import { ApiCommonService } from 'src/app-core/services/api-common.service';
import { Observable } from 'rxjs';
import { CommonService } from 'src/app-core/services/common.service';

@Injectable({
  providedIn: 'root'
})
export class ItemService {

  constructor(
    private apiCommonService: ApiCommonService,
    private commonService: CommonService
  ) {
  }

  getCategories(): Observable<any> {
    return this.apiCommonService.get(`Item/ItemCategoryLookUp`);
  }

  create(data: object): Observable<object> {
    return this.apiCommonService.post('Item', data);
  }

  getGridRecords(event: any, searchQuery: string, statusQuery: string): Observable<any> {
    return this.apiCommonService.getGridRecords('Item', event, searchQuery, statusQuery, '');
  }

  editItem(itemId: string): Observable<any> {
    return this.apiCommonService.get(`Item/Edit?Id=${itemId}`);
  }

  update(data: object): Observable<object> {
    return this.apiCommonService.post('Item/Update', data);
  }

  itemStatusUpdate(data: object): Observable<object> {
    return this.apiCommonService.put('Item/Delete', data);
  }

  exportItems(event: any, searchQuery: string, queryString: any): Observable<object> {
    return this.apiCommonService.export('Item/export', event, searchQuery, queryString, '');
  }

  getItemLookup(queryString: string): Observable<any> {
    return this.apiCommonService.get(`Item/Lookup${queryString ? '?' + queryString : ''}`);
  }

  getItem(query: string): Observable<any> {
    return this.apiCommonService.get(`Item/Id?${query}`);
  }
}
